import { DealCreateRequest } from '@asgard/api-common';
import { Logger } from '@asgard/ui-common';
import { getApiPathUrl } from 'utils/api';
import * as fetch from 'utils/fetch';

/**
 * Service to interact with Manfred public Deal
 */
export const ServiceDeal = {
  /**
   * Create a new Deal for Manfred
   *
   * @param dealInfo Info to create the new deal
   */
  create: async (dealInfo: DealCreateRequest): Promise<void> => {
    const url = getApiPathUrl('/v2/public/ui/deal');

    Logger.info({
      context: 'ServiceDeal',
      message: `Sending request to create a new deal`,
      object: dealInfo
    });

    return fetch.post<DealCreateRequest, void>(`${url}`, dealInfo);
  }
};
